import { mapKeys, snakeCase } from 'lodash';

export default object => mapKeys(object, (value, key) => snakeCase(key));



// WEBPACK FOOTER //
// ./src/utils/toSnakeCaseObjectKeys.js